import TeamManagementList from "./serviceteamManagementList";
export default TeamManagementList;